import { getDeepLink } from '@/lib/constants';
import { useContentList } from '@/lib/hooks/use-content';
import { useNavigate } from 'react-router-dom';
import AudioCard from '../audio-card';
import Loading from '../loading';
import { ContentType } from '@/types/custom';

interface ContentGridProps {
  maxItems?: number;
  articlesOnly: boolean;
}

/**
 * Display a grid of most recent content items.
 */
export function ContentGrid({ maxItems = 4, articlesOnly }: ContentGridProps) {
  const navigate = useNavigate();
  const { contentWithConfigs, loading } = useContentList(
    articlesOnly ? 'article' : '*',
  );

  const recentContent = contentWithConfigs
    .filter((item) => item.content.published)
    .filter((item) =>
      articlesOnly
        ? true
        : item.content.content_type !== ('article' satisfies ContentType),
    )
    .slice(0, maxItems);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        {loading && <Loading />}
        {!loading &&
          recentContent.map((item) => (
            <AudioCard
              key={item.content.id}
              content={item.content}
              showLabel={true}
              onClick={() => {
                navigate(
                  getDeepLink(item.content.content_type, item.content.id),
                );
              }}
            />
          ))}
      </div>
    </div>
  );
}
